import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Nephrologist icon
 *
 * @category Medical
 */
const Nephrologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M23 3.963c8.395.058 8.117 16.186.268 16.615-3.084-.07-3.64-2.933-3.35-5.298.035-.8-.082-1.16-.383-.836-2.956 4.059-.895 14.58-2.043 14.532-1.146-.05-.635-6.67-.636-7.076.012-2.145-.022-4.302.754-6.319.603-1.68 1.785-2.852 1.959-3.896.22-1.507-.602-3.026-.428-4.556.14-1.878 1.646-3.165 3.64-3.166zm-15.982.295c2.273-.847 5.543.162 6.1 2.689.35 1.556-.014 3.751-.668 5.21.122.394.501.254.958.761 1.364 1.52 1.596 3.722 1.689 5.693.139 3.153.342 10.336-.401 10.354-.743.016-.648-3.006-.655-3.316-.127-3.64.93-7.862-.936-10.934-.533-.811-.603-.069-.533 1.334.568 5.332-5.599 5.773-7.814 1.692C2.58 13.777 2.231 6.206 7.018 4.258m16.969.71c-1.646-.416-3.687.389-3.895 2.452-.176 1.433.178 2.899.574 4.3.396-.07.836-.07 1.172-.155.742-.035 1.965.098 2.734-.89.77-.99.834-.145.676.23-.142.338-.575 1.603-3.027 1.672-.527.015-.717.289-.286.591.6.421 1.45.952 1.642 1.4.336.731.777 2.041.07 2.62-.197.117-.441-.022-.592-.3-.278-.534-.382-1.427-.81-2.007a3.6 3.6 0 0 0-1.269-1.213c.009 2.52-1.02 6.21 2.292 6.211 6.162 0 7.112-13.705.719-14.91M12.45 8.12c-.21-2.701-3.198-4.023-5.61-2.75-4.492 2.608-3.125 14.308 2.37 14.297h.209c3.651-.352 2.324-3.742 1.995-6.132-.032.015-.064.033-.097.045-.44.174-1.17.615-1.657 1.403-.429.58-.534 1.472-.812 2.005-.15.278-.394.417-.591.302-.707-.58-.267-1.89.07-2.62.191-.45 1.042-.98 1.642-1.401.431-.303.241-.575-.285-.59-2.451-.07-2.887-1.334-3.03-1.672-.157-.375-.092-1.22.677-.231.77.989 1.992.856 2.734.89.4.1.946.079 1.39.2.307-1.325 1.033-2.485.995-3.746"
        />
      </svg>
    );
  }
);

Nephrologist.displayName = 'Nephrologist';

export { Nephrologist };
